export enum SmartFleetContractType {
    UNSPECIFIED = 'unspecified',
    MANAGEMENT = 'management',
    PURCHASE_CONSULTANT = 'purchase-consultant',
}
